declare var __GlobalSettings: any;

export const GLOBAL_CONSTANTS = {
    environment: __GlobalSettings.Env,
    appVersion: __GlobalSettings.AppVersion,
    appBuild: __GlobalSettings.BuildYear + "." + __GlobalSettings.Minor,
    appIteration: ""
}



// WEBPACK FOOTER //
// ./src/commons/constants/globals.ts